module.exports = __webpack_public_path__ + "static/media/waiting.acfb21c4.png";